<template>
  <t-layout :showNav="false">
    <div class="receive-page">
      <div v-if="!info.hasBind" class="empt-content">
        <img
          class="empt-icon"
          src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/card-empt.png"
        />
        <div class="add-btn" @click="tobindBank">
          <img src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/add-icon.png" /><span
            >添加兑奖银行卡</span
          >
        </div>
      </div>

      <div v-else class="bank-content">
        <div class="card">
          <div class="infos">
            <img
              class="empt-icon"
              src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/card-empt.png"
            />
            <div class="cont">
              <p>{{ info.bank }}</p>
              <p>{{ info.bank_user_name }}</p>
            </div>
          </div>
          <div class="no">{{ info.bank_card_no }}</div>
        </div>

        <div class="add-btn edit-btn" @click="tobindBank">
          <span>修改银行卡</span>
        </div>
      </div>

      <div class="tips">
        <div class="title">兑奖须知</div>

        <p>
          1、双色球兑奖当期有效。中奖者应当自开奖之日起60个自然日内，持中奖彩票到指定的地点兑奖。逾期未兑奖视为弃奖，弃奖奖金纳入彩票公益金。
        </p>
        <p>2、中奖彩票为中奖唯一凭证，中奖彩票因玷污、损坏等原因不能正确识别的，不能兑奖。</p>
        <p>3、兑奖机构可以查验中奖者的中奖彩票及有效身份证件，中奖者兑奖时应予配合。</p>
        <p>
          双色球根据购买者所选单式投注号码（复式和胆拖投注按其包含的每一注单式投注计）与当期开奖号码的相符情况，确定相应的中奖资格。
        </p>
      </div>
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'receiveView',
  components: {},
  data() {
    return {
      user_coupon_id: null,
      url: '',
      info: {
        hasBind: false
      },
      tkn: ''
    }
  },
  created() {},
  activated() {
    window.scrollTo(0, 0)
    this.$store.commit('setTitle', '奖金派发账户')
    const options = this.$route.query
    this.user_coupon_id = options.user_coupon_id
    this.getLotteryAddress('query', Number(this.user_coupon_id))
  },
  methods: {
    tobindBank() {
      this.$router.push({
        path: `/lottery/bankCard?user_coupon_id=${this.user_coupon_id}`
      })
    },

    getLotteryAddress(type, user_coupon_id) {
      this.$api.coupon.getLotteryAddress({ type, user_coupon_id }).then(result => {
        let res = result.data
        if (res.code == 0) {
          const { url } = res.data
          this.url = url

          this.getLotteryBindBank()
        }
      })
    },

    getLotteryBindBank() {
      this.$api.coupon.getLotteryBindBank({ url: this.url }).then(result => {
        let res = result.data
        if (res.code == 0 && res.data) {
          this.info = res.data.ret
          this.tkn = res.data.tkn
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.receive-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 20rpx;

  .add-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ff5566;
    font-size: 30rpx;
    font-weight: 500;
    height: 92rpx;
    border: 2rpx solid #ff5566;
    border-radius: 4rpx;

    img {
      display: block;
      width: 32rpx;
      height: 32rpx;
      margin-right: 12rpx;
    }

    span {
      line-height: 92rpx;
      display: block;
    }

    &.edit-btn {
      background: #ff5566;
      color: #fff;
    }
  }

  .empt-content {
    width: 100%;
    padding: 54rpx 32rpx 32rpx;
    background: #ffffff;

    .empt-icon {
      display: block;
      width: 190rpx;
      height: 190rpx;
      margin-bottom: 36rpx;
      margin: 0 auto;
    }
  }

  .bank-content {
    .card {
      width: 100%;
      height: 240rpx;
      background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/card-bg.png');
      background-origin: 0 0;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding: 40rpx;
      margin-bottom: 40rpx;

      .infos {
        display: flex;
        align-items: center;
        margin-bottom: 40rpx;

        > img {
          display: block;
          width: 72rpx;
          height: 72rpx;
          margin-right: 24rpx;
        }

        .cont {
          p {
            margin: 0;
            color: rgba(255, 255, 255, 0.6);
            font-size: 26rpx;
            line-height: 30rpx;

            &:nth-child(1) {
              font-size: 30rpx;
              font-weight: 500;
              margin-bottom: 12rpx;
              color: #fff;
            }
          }
        }
      }

      .no {
        font-weight: 500;
        color: #fff;
        font-size: 40rpx;
        letter-spacing: 2rpx;
      }
    }
  }

  .tips {
    margin-top: 40rpx;
    padding: 40rpx 24rpx;
    .title {
      font-size: 26rpx;
      color: #353738;
      font-weight: 500;
      text-align: center;
      margin-bottom: 16rpx;
    }

    p {
      margin: 0;
      font-size: 26rpx;
      color: #8c8c8c;
      line-height: 42rpx;

      &:last-child {
        margin-top: 40rpx;
      }
    }
  }
}
</style>
